<template>
  <div class="page">
	<div class="sidebar">
		<sidebar></sidebar>
	</div>
  	<div class="pageContainer">
  		<div class="pageTitle">
  			<h3>2020国际学院版画联盟云展</h3>
  			<!-- <small>/ 国际学院版画联盟</small> -->
  		</div>
  		<div class="pageContent">
  			<div class="pageArticle">
  				<p>2016年9月25日，中国首届国际版画大展在北京太庙艺术馆举办，来自30多个国家的200多位艺术家所创作的700多件作品在此展出。在展览的研讨会现场，我萌生了建立一个国际学院版画联盟的想法，并将此想法征求与会艺术家的意见，得到了各国同行的一致认同。至此，全球最大、水平最高的第一个跨国版画联盟诞生了。</p>
	  			<p>2018年9月7日，第二届国际学院版画联盟大展在景德镇陶溪川美术馆开展。在此次展览的研讨会上，针对版画的技术语言和市场的需要，我提出了对版画概念进行讨论的议题。与会的各国版画精英们对版画的新定义达成了共识，并签署了一份声明，一致赞同把数码版画、独幅版画和摄影纳入版画范畴，承认他们与传统木刻、铜版，石版和丝网等都有平等的地位，可以参加版画展览和版画收藏，同时，认可对名画和经典作品的利用和改造也具有同等的学术与收藏价值。这个关于版画定义的声明，拓展了版画的内涵和外延，结束了大众对版画的盲区与短见，对版画发展具有里程碑式的意义。</p>
	  			<p>2020年10月18日，第三届国际版画联盟大展即将举办。与往年不同的是，由于新冠疫情的影响，我们此次将放弃现场展览而改为线上展览。同时，我们将宣布中央美术学院国际版画研究院成立，这是国际版画界的另一件大事。作为国际版画联盟的发起人和几次大展的策划者与组织者，我要特别感谢中央美术学院领导，感谢国际国内杰出的版画家们，感谢支持和资助我们的各地美术馆，企业家，感谢我的助手和展览团队，没有你们的支持和帮助，就不可能有今天享誉世界的国际学院版画联盟，也不会有版画联盟的未来。预祝国际版画联盟云展顺利开幕和圆满成功。祝贺中央美术学院国际版画研究院成立，并为国际版画的发展做出积极的贡献。</p>
	  			<br/>
	  			<br/>
	  			<p class="right">王华祥<br/>2020/10/11</p>
  			</div>
  		</div>
  	</div>
  </div>
</template>

<script type="text/ecmascript-6">
	import Sidebar from 'base/sidebar/sidebar'
	export default {
	  	components: {
	  		Sidebar
	  	}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.pageContent {
	    padding: 52px 30px;
	}
	.pageArticle .right{
		text-align: right;
	}

	@media screen and (max-width:750px) {
		.pageContent {
		    padding: .4rem;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/preface/preface.vue